// src/utils/evaluationUtils.js

export const getGlobalAverage = (totalResults) => {
    if (!totalResults) return 0;

    const directAverage = Number(totalResults.average);
    if (Number.isFinite(directAverage)) return directAverage;

    const dimensions = Object.values(totalResults.average_by_dimension || {});
    if (dimensions.length === 0) return 0;

    const sum = dimensions.reduce((acc, d) => acc + (d.average || 0), 0);
    return Math.round((sum / dimensions.length) * 10) / 10;
};
